import React, { useEffect, useState } from "react";
import Common_Back_Btn from "../../../../../common/common_components/common_back_btn/Common_Back_Btn";
import Common_Report_Offcanvas from "../../common_report_offcanvas/Common_Report_Offcanvas";
import { Nav, Tab } from "react-bootstrap";
import Internal_Audit from "./inner_tabs/internal_audit/Internal_Audit";
import MRM from "./inner_tabs/mrm/MRM";
import Risk from "./inner_tabs/risk/Risk";
import { useDispatch, useSelector } from "react-redux";
import { GetAll } from "../../../../../../src/features/admin/quality_management/management_system/Slice";
import {
  GetCustomerReport,
  GetManagementReport,
  GetValidityReport,
} from "../../../../../features/admin/report_generator/Slice";
import { allManagement_System_Requirement_Status } from "../../../../../features/admin/common/Slice";
const Management_System = () => {
  const [show, setShow] = useState(false);

  const tabs = ["Internal Audit", "MRM", "Risk & Opportunities"];
  const dispatch = useDispatch();

  const [currentPage, setCurrentPage] = useState(1);
  const [activeManagementTypeId, setActiveManagementTypeId] = useState(1);

  const managementdetails = useSelector((state) => state.management_system);
  const [searchParams, setSearchParams] = useState({
    start_date: "",
    end_date: "",
    status_id: "",
    name: "",
  });
  const fetchRecords = async (
    page = 1,
    activeManagementId = activeManagementTypeId,
  ) => {
    if (activeManagementId && activeManagementId !== "") {
      await dispatch(
        GetAll({
          page,
          per_page: managementdetails.per_page,
          management_system_type_id: activeManagementId || 1,
          start_date: searchParams?.start_date,
          end_date: searchParams?.end_date,
          status_id: searchParams?.status_id?.value,
          term: searchParams?.name,
        }),
      );
    }
  };

  // Initial load
  useEffect(() => {
    fetchRecords(currentPage, activeManagementTypeId);
  }, [activeManagementTypeId, currentPage,searchParams]);

  const [activeTab, setActiveTab] = useState("Internal_Audit");

  const handleTabChange = (key) => {
    setActiveTab(key);

    const tabMapping = {
      Internal_Audit: 1,
      MRM: 2,
      Risk_Opportunities: 3,
    };

    setActiveManagementTypeId(tabMapping[key]);
    setCurrentPage(1);
  };
 const [name, setName] = useState("");
  const [showLottie, setShowLottie] = useState(true);
  const [reportPath, setReportPath] = useState("");
  const reportgenerate = async (name) => {
     setName(name);
    setShow(true);
    setShowLottie(true);
    const response = await dispatch(
      GetManagementReport({
        management_system_type_id: activeManagementTypeId,
        name: name,
        start_date: searchParams?.start_date,
        end_date: searchParams?.end_date,
        status_id: searchParams?.status_id?.value,
        term: searchParams?.name,
      }),
    );

    if (response?.meta?.requestStatus === "fulfilled") {
      const path = response?.payload?.path;
      setReportPath(path);
      setShowLottie(false);
    } else {
      setShowLottie(false); // also stop loader on error
    }
  };

  useEffect(() => {
    dispatch(allManagement_System_Requirement_Status());
  }, [dispatch]);
  return (
    <section className="Sample_Report">
      <div className="back_div">
        <Common_Back_Btn backText="Management System Requirement" />
      </div>

      <div className="tables_tab_section">
        <Tab.Container activeKey={activeTab} onSelect={handleTabChange}>
          <Nav variant="pills">
            <Nav.Item>
              <Nav.Link eventKey="Internal_Audit">Internal Audit</Nav.Link>
            </Nav.Item>

            <Nav.Item>
              <Nav.Link eventKey="MRM">MRM</Nav.Link>
            </Nav.Item>

            <Nav.Item>
              <Nav.Link eventKey="Risk_Opportunities">
                Risk Opportunities
              </Nav.Link>
            </Nav.Item>
          </Nav>

          <Tab.Content className="inner-tab-sec">
            <Tab.Pane eventKey="Internal_Audit">
              <Internal_Audit
                reportgenerate={reportgenerate}
                setSearchParams={setSearchParams}
                managementdetails={managementdetails}
                currentPage={currentPage}
                setCurrentPage={setCurrentPage}
              />
            </Tab.Pane>

            <Tab.Pane eventKey="MRM">
              <MRM
              reportgenerate={reportgenerate}
                setSearchParams={setSearchParams}
                managementdetails={managementdetails}
                currentPage={currentPage}
                setCurrentPage={setCurrentPage}
              />
            </Tab.Pane>

            <Tab.Pane eventKey="Risk_Opportunities">
              <Risk
              reportgenerate={reportgenerate}
                setSearchParams={setSearchParams}
                managementdetails={managementdetails}
                currentPage={currentPage}
                setCurrentPage={setCurrentPage}
              />
            </Tab.Pane>
          </Tab.Content>
        </Tab.Container>
      </div>

    
      <Common_Report_Offcanvas
        reportPath={reportPath}
        reportgenerate={reportgenerate}
        setShowLottie={setShowLottie}
        showLottie={showLottie}
        title={name||"Internal Audit Report"}
        show={show}
        setShow={setShow}
        handleClose={() => {
          setShow(false);
        }}
      />
    </section>
  );
};

export default Management_System;
